/**
 * @desc 查询月计划tab页标题名称
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<Array<defs.PlanMonthTabResponse>>> {
  return defHttp.post({
    url: '/wap/plan/month/queryPlanTabs',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<Array<defs.PlanMonthTabResponse>>> {
  return defHttp.post({
    url: '/mock/wap/plan/month/queryPlanTabs',
    data,
  });
}
